<div style="align-self:center; height: 100%; width: 100%">
  <google-chart 
    [type]="chartType" 
    [data]="chartData" 
    [columns]="chartColumns" 
    [options]="chartOptions">
  </google-chart>
</div>